import PropTypes from 'prop-types';
import { toAudString } from 'utils/currency';
import { EventsSummary } from './EventsSummary/EventsSummary';
import { DonationsSummary } from './DonationsSummary';
import { PurchasedGiftCertificatesSummary } from './PurchasedGiftCertificatesSummary';
import { MembershipsSummary } from './MembershipsSummary';
import { RedeemedGiftCertificatesSummary } from './RedeemedGiftCertificatesSummary';
import './BookingOrderSummary.scss';

export const BookingOrderSummary = (props) => {
  const {
    Order: {
      OrderTotal,
      Cart: {
        DonationItems,
        Fees,
        PerformanceTickets,
        PurchasedGiftCertificates,
        RedeemedGiftCertificates,
        MembershipItems,
        OriginalOrderSubTotal,
        OrderSubTotal,
        TotalLineItem,
      },
    },
    OrderDataLayer: {
      PerformanceTickets: PerformanceTicketsDataLayer,
    },
    allowRemove = true,
    stepName = 'Delivery Options',
  } = props;
  PerformanceTickets.forEach((ticket, i) => Object.assign(ticket, PerformanceTicketsDataLayer[i]));
  PerformanceTickets.sort((a, b) => b.IsUpsellItem - a.IsUpsellItem);

  return (
    <div className="booking-order-summary" data-testid="booking-order-summary">
      {PerformanceTickets.length > 0 &&
        PerformanceTickets.map((performanceTicket, index) => (
          <EventsSummary
            performanceTicket={performanceTicket}
            totalLineItem={TotalLineItem}
            key={index}
            allowRemove={allowRemove}
            stepName={stepName}
          />
        ))}

      {DonationItems.length > 0 && (
        <DonationsSummary
          donationItems={DonationItems}
          totalLineItem={TotalLineItem}
          allowRemove={allowRemove}
          stepName={stepName}
          redeemedGiftCertificates={RedeemedGiftCertificates}
        />
      )}

      {PurchasedGiftCertificates.length > 0 && (
        <PurchasedGiftCertificatesSummary
          purchasedGiftCertificates={PurchasedGiftCertificates}
          allowRemove={allowRemove}
          stepName={stepName}
          redeemedGiftCertificates={RedeemedGiftCertificates}
        />
      )}

      {/* Render each membership summary */}
      {MembershipItems.length > 0 && (
        <MembershipsSummary
          membershipItems={MembershipItems}
          allowRemove={allowRemove}
          stepName={stepName}
          redeemedGiftCertificates={RedeemedGiftCertificates}
        />
      )}

      {OriginalOrderSubTotal > OrderSubTotal && (
        <>
          <hr />
          <div className="text-right">
            <span className="info-label">Original Subtotal</span>
            <br />
            <span className="price-old">{toAudString(OriginalOrderSubTotal)}</span>
          </div>
        </>
      )}

      <div className="text-right">
        <span className="info-label">Cart Subtotal</span>
        <br />
        {toAudString(OrderSubTotal)}
      </div>

      {Fees.length > 0 && (
        <>
          <span className="info-label">Fees</span>

          {Fees?.map((fee, index) => {
            const { Description, Amount } = fee;

            return (
              <div className="row" key={index}>
                <div className="col-xs-8">{Description}</div>
                <div className="col-xs-4 text-right">{toAudString(Amount)}</div>
              </div>
            );
          })}
        </>
      )}

      {/* Render each RedeemedGiftCertificates */}
      {RedeemedGiftCertificates.length > 0 && (
        <RedeemedGiftCertificatesSummary
          redeemedGiftCertificates={RedeemedGiftCertificates}
          totalLineItem={TotalLineItem}
          allowRemove={allowRemove}
          stepName={stepName}
        />
      )}

      <hr className="hr-double" />

      <div className="text-right">
        <span className="info-label">Order total</span>
        <br />
        <span className="info-label">AUD</span>{' '}
        <span className="price-total">{toAudString(OrderTotal)}</span>
        <p>
          <span className="info-label">
            <small>Price is inclusive of GST</small>
          </span>
        </p>
      </div>
    </div>
  );
};

export const BookingOrderSummarySC = (props) => {
  const { sitecoreData } = props;
  return <BookingOrderSummary {...sitecoreData} />;
};

BookingOrderSummarySC.propTypes = {
  sitecoreData: PropTypes.object,
};

BookingOrderSummary.propTypes = {
  Order: PropTypes.object.isRequired,
  OrderDataLayer: PropTypes.object.isRequired,
  allowRemove: PropTypes.bool,
  stepName: PropTypes.string,
};
